import { render, staticRenderFns } from "./SampleFuncCard.vue?vue&type=template&id=00ea73bf&scoped=true"
import script from "./SampleFuncCard.vue?vue&type=script&lang=ts"
export * from "./SampleFuncCard.vue?vue&type=script&lang=ts"
import style0 from "./SampleFuncCard.vue?vue&type=style&index=0&id=00ea73bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea73bf",
  null
  
)

export default component.exports